// eslint-disable-next-line @typescript-eslint/no-redeclare
export const User = Symbol('User');
